import React from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'
import { Spinner } from './Spinner'
import { FlowRouter } from './FlowRouter'
import { useSetLanguage } from 'hooks/useSetLanguage'
import { useCleanDataByCohortChange } from 'hooks/useCleanDataByCohortChange'
import { useCleanDataByLeadIdChange } from 'hooks/useCleanDataByLeadIdChange'
import { useGetFirstLead } from 'hooks/useGetFirstLead'
import { useGetPlans } from 'hooks/useGetPlans'
import { useLoadStripe } from 'hooks/useLoadStripe'
import { useSetInitialCohort } from 'hooks/useSetInitialCohort'
import { useScrollToTopByRouteChange } from 'hooks/useScrollToTopByRouteChange'
import { useGetRemoteConfigVariantData } from 'hooks/useGetRemoteConfigVariantData'
import { useGetGrowthbookVariantData } from 'hooks/useGetGrowthbookVariantData'
import { useIsFlowVariantResolved } from 'hooks/useIsFlowVariantResolved'

export const SubscribeFlow: React.FC = () => {
  const { lead, cohortLeadPlans } = useZustandStore(
    useShallow((state) => ({
      lead: state.lead,
      cohortLeadPlans: state.cohortLeadPlans,
    })),
  )

  useScrollToTopByRouteChange()
  useSetInitialCohort()
  useCleanDataByCohortChange()
  useCleanDataByLeadIdChange()
  useSetLanguage()
  useGetFirstLead()
  useGetPlans()
  useLoadStripe()
  // Must run before the flow-variant gate below, so the machine and route
  // list built in FlowRouter always see the resolved flow variant.
  useGetRemoteConfigVariantData()
  useGetGrowthbookVariantData()

  const isFlowVariantResolved = useIsFlowVariantResolved()

  return lead && cohortLeadPlans && isFlowVariantResolved ? (
    <FlowRouter />
  ) : (
    <Spinner />
  )
}
